
import apiURL from './apiURL';
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
  MY_CURRENT_AGREEMENT: "MY_CURRENT_AGREEMENT",
  MY_UPDATE_AGREEMENTS: "MY_UPDATE_AGREEMENTS",
  MY_GET_TIMSHEEETS: "MY_GET_TIMSHEEETS",
  MY_UPDATE_TIMSHEEETS: "MY_UPDATE_TIMSHEEETS",
  MY_SAVE_CURRENT_TIMESHEET: "MY_SAVE_CURRENT_TIMESHEET",
};

const myUpdateCurrentAgreement = agreement => ({
  type: Types.MY_CURRENT_AGREEMENT,
  agreement
});

const myUpdateAgreements = response => ({
  type: Types.MY_UPDATE_AGREEMENTS,
  payload: response
});

const myGetAgreements = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/my/agreements` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(myUpdateAgreements(data))
    })
  }
}

const myUpdateTimesheets = response => ({
  type: Types.MY_UPDATE_TIMSHEEETS,
  payload: response
});

const myGettingTimesheets = () => ({
  type: Types.MY_GET_TIMSHEEETS,
});

const myGetTimesheets = (from,to) => {
  return (dispatch, getState) => {

    const currentAgreement = getState().my.currentAgreement;
    dispatch(myGettingTimesheets())

    fetch(apiURL + `/my/timesheets/${currentAgreement}?from=${from}&to=${to}` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(myUpdateTimesheets(data))
    })
  }
}

const timesheetUpdateSaveStatus = response => ({
  type: Types.MY_SAVE_CURRENT_TIMESHEET,
  payload: response
});

const mySaveTimesheet = (timesheet) => {
  return (dispatch, getState) => {

    fetch(apiURL + `/my/timesheet` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({timesheet}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(timesheetUpdateSaveStatus(data))
    })
  }
}

const Actions = {
  myGetAgreements,
  myGetTimesheets,
  myUpdateCurrentAgreement,
  mySaveTimesheet,
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions